import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Link, graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

const Wrapper = styled.div<LogoProps>`
  width: 180px;

  & img {
    cursor: pointer;
  }

  ${({ isWhite }) =>
    isWhite &&
    css`
      filter: invert(100%);
    `}
`;

interface LogoProps {
  isWhite?: boolean;
}

const Logo: FC<LogoProps> = ({ isWhite }) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo-white.png" }) {
        childImageSharp {
          fluid(maxWidth: 360, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  return (
    <Link to="/">
      <Wrapper isWhite={isWhite}>
        <Img
          fluid={data.logo.childImageSharp.fluid}
          alt="Eimantas Gulbinas Consulting"
        />
      </Wrapper>
    </Link>
  );
};

export default Logo;
